/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Account } from '../../../model/Account';
import { Command } from '../../../model/Command';
import { Filter } from '../../../model/Filter';
import { BaseController } from '../../BaseController';

class AccountViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, accountService, companyService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, $scope, dialogService, authenticationService, profileService, accessProfileService,
        filterService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.accountService = accountService;
        this.companyService = companyService;
        this.profileService = profileService;
        this.accessProfileService = accessProfileService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$log.debug('Controller \'AccountView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.commands = [];
        this.account = new Account();

        let entityPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.account.update';
            entityPromise = this.accountService.getEntity(this.$stateParams.id);
        } else {
            this.updateMode = false;
            this.title = 'ui.account.creation';
            entityPromise = this.$q.resolve();
        }

        this.handleRestServiceCall(this.$q.all({
            entity: entityPromise,
            companies: this.companyService.findEntities(),
            profiles: this.profileService.findEntities({
                data: this.filterService.buildFilters([Filter.equalFilter('system', false)])
            }),
            accessProfiles: this.accessProfileService.findEntities()
        }), data => {
                this.pristineEntity = new Account(data.entity);
                this.companies = data.companies;
                this.profiles = data.profiles;
                this.accessProfiles = data.accessProfiles;
                this.reset();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.accountService.updateEntity(this.account);
        } else {
            serviceActionPromise = this.accountService.createEntity(this.account);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.account.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.organization.account.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    /**
     * Restores the initial state of the view.
     */
    reset() {
        this.account = angular.copy(this.pristineEntity);
    }
}

export const accountViewComponent = {
    template: require('./account-view.html'),
    controller: AccountViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/AccountView.js